import React, { useEffect, useState } from "react";
import TableCtsm from '../../../../TableCstm/TableCstm';
import './PaymentHistory.scss'
import { getLocalDateObjectFromInput, getLocalDateString, toYMD } from "../../../../../utils/dateTimeZone";
import Tooltip from "../../../../Tooltip/Tooltip";
import Button from "../../../../button/button";
import PrintSVG from '../../../../icons/print'
import { GetPaymentReceiptByIDToReprint } from "../../../../../utils/Apis/receptionApis";
import { getClassDateOfWeek } from "../../../../../utils/dateUtils";
import { getPresentialPaymentType } from "../../../../../utils/receptionUtils/payment";
import RefundSVG from "../../../../icons/refund";
import CancelSVG from "../../../../icons/cancel";
import ChangeArrowSVG from "../../../../icons/changeArrows";
import ConfirmModal from "../../../../ConfirmModalV3/confirmModal";
const PaymentHistory = ({ student, paymentPlan, setReceiptData, setIsOpenPrintReceipt, openConfirm, showActions = true, className = '' }) => {
    const { paymentHistory = [] } = student;


    if (!paymentHistory || paymentHistory.length === 0) {
        return null;
    }

    const formatDate = (date) => {
        let localDate;
        if (typeof date === 'string') {
            localDate = getLocalDateObjectFromInput(date);
        } else {
            localDate = date;
        }
        const day = String(localDate.getDate()).padStart(2, '0');
        const month = String(localDate.getMonth() + 1).padStart(2, '0');
        const year = localDate.getFullYear();
        return `${day}/${month}/${year}`;
    };

    // Función para calcular el rango de fechas de una semana
    const getWeekDateRange = (weekNumber, year) => {
        // Obtener el 4 de enero del año dado (para cumplir con la norma ISO 8601)
        const fourthOfJanuary = new Date(year, 0, 4);

        // Calcular el lunes de la primera semana ISO 8601 (restando los días necesarios para llegar al lunes)
        const firstMonday = new Date(fourthOfJanuary);
        firstMonday.setDate(fourthOfJanuary.getDate() - (fourthOfJanuary.getDay() + 6) % 7);
        // Calcular el inicio de la semana deseada sumando (weekNumber - 1) * 7 días
        const startOfWeek = new Date(firstMonday);
        startOfWeek.setDate(firstMonday.getDate() + (weekNumber - 1) * 7);

        // Calcular el final de la semana (sumando 6 días al inicio)
        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);

        return { start: startOfWeek, end: endOfWeek };
    };

    // Función para combinar semanas consecutivas
    const combineConsecutiveWeeks = (weeks) => {
        let combined = [];
        let currentRange = null;

        weeks.forEach((week, index) => {
            const [weekNumber, year] = week.split("-");
            if (!weekNumber || !year) return; // Verificar si weekNumber o year están vacíos

            const { start, end } = getWeekDateRange(Number(weekNumber), Number(year));

            if (!start || !end) return; // Verificar si las fechas de inicio y fin son válidas

            if (currentRange === null) {
                currentRange = { start, end };
            } else {
                const prevEnd = currentRange.end;
                if (start.getTime() === prevEnd.getTime() + 86400000) { // Comprobar si son consecutivas
                    currentRange.end = end; // Extender el rango
                } else {
                    combined.push(`${formatDate(currentRange.start)} - ${formatDate(currentRange.end)}`);
                    currentRange = { start, end }; // Iniciar un nuevo rango
                }
            }
        });

        if (currentRange !== null) {
            combined.push(`${formatDate(currentRange.start)} - ${formatDate(currentRange.end)}`);
        }

        return combined.join(", ");
    };


    const columns = [
        { header: "Acciones", accessor: "actions", className: "tableCtype5 td" },
        { header: "No.Recibo", accessor: "receiptId", className: "tableCtype3 td" },
        { header: "Fecha", accessor: "date", className: "tableCtype3 td" },
        { header: "Concepto", accessor: "concept", className: "tableCtype2 td" },
        { header: "Semanas", accessor: "weeksPaid", className: "tableCtype1 td" },
        { header: "", accessor: "dateRange", className: "tableCtype5 td" },
        { header: "Monto", accessor: "amount", className: "tableCtype3 td" },
        { header: "Porcentaje pagado colegiatura", accessor: "percent_paid", className: "tableCtype5 td" },
        { header: "Estudiantes", accessor: "receiptType", className: "tableCtype1 td" },

    ];
    //Function to split weeks paid fully and partial pays
    const filterWeeks = (payment) => {
        // filter fully paid weeks
        const fullyPaidWeeks = payment.payedWeeks
            .filter(week => {
                return parseInt(week.percent_paid) === 100;  // Compara como número
            });

        // filter week partial pays
        const partialPays = payment.payedWeeks
            .filter(week => {
                return parseInt(week.percent_paid) !== 100;  // Compara como número
            });

        //Format the dates 
        const fullyPaidWeeksStr = fullyPaidWeeks.length > 0
            ? combineConsecutiveWeeks(fullyPaidWeeks.map(week => week.week))
            : "-"

        const partialPaysStr = partialPays.length > 0
            ? combineConsecutiveWeeks(partialPays.map(week => week.week)) : "-"

        return (
            <div className="week-range">
                <p className="fully-paid">{fullyPaidWeeksStr}</p>
                {partialPays.length > 0 && (
                    <p className={parseInt(partialPays[0].paid_is_active) === 1 ? "partial-pay" : 'partial-pay-inactive'}>{partialPaysStr}</p>
                )}
            </div>
        );
    }
    const splitConcepts = (concepts = {}) => {
        return (
            <div className="concepts">
                {Object.entries(concepts).map(([concept, percent], index) => {
                    const numericPercent = parseFloat(percent.replace('%', ''));
                    const isPartial = numericPercent < 100 && numericPercent !== 0;

                    return (
                        <span
                            key={index}
                            className={`concept-item ${isPartial ? 'partial-pay' : ''}`}
                        >
                            {`${concept}, `}
                        </span>
                    );
                })}
            </div>
        );
    };
    function roundToNearestHalf(value) {
        return Math.round(value * 2) / 2;
    }
    //Function to get de week number of a date
    function getWeekNumber(date) {
        const tempDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        // Ajustar para que la semana inicie en lunes
        tempDate.setUTCDate(tempDate.getUTCDate() + 4 - (tempDate.getUTCDay() || 7));
        // Calcular el inicio del año
        const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
        // Calcular la diferencia en días y obtener la semana
        const weekNumber = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);

        return { weekNumber, year: tempDate.getUTCFullYear() };
    }

    const splitPercents = (
        conceptPercentages,
        amountStr,
        fullHistory = [],
        currentReceiptId = null,
        payedWeeks = [],
        concept_st
    ) => {
        if (!conceptPercentages) return ["-"];
        const amounts = amountStr?.split(',').map(a => a.trim()) || [];
        const payedWeeksToUse = payedWeeks?.map(({ week }) => {
            const [weekNum, year] = week.split('-').map(Number);
            return { weekNum, year };
        });

        const classDays = student.class_days; //string: "Lunes,martes,miercoles,etc"
        // const isClassOnline = student.is_online //Retorna true o false
        const isClassOnline = paymentPlan.is_online === 1 //Retorna true o false
        const today = getLocalDateString();
        const percentJSX = (
            <div className="percents">
                {Object.entries(conceptPercentages).map(([concept, percent], index) => {
                    const amount = amounts[index] ? parseFloat(amounts[index]) : null;
                    const percentNumber = parseFloat(percent);
                    let extraInfo = '';
                    const conceptStatus = concept_st?.[concept];
                    const isPaid = conceptStatus === 'PAID';
                    const isRefunded = conceptStatus && conceptStatus !== 'PAID';
                    let conceptNameST
                    switch (conceptStatus) {
                        case 'PARTIAL REFUNDED':
                            conceptNameST = 'Reembolso parcial'
                            break;
                        case 'REFUNDED':
                            conceptNameST = 'Reembolsado'
                            break;
                        case 'CANCELLED':
                            conceptNameST = 'Cancelado'
                            break
                        default:
                            break;
                    }

                    if (concept === 'Abono' && percentNumber < 100 && percentNumber !== 0 && amount !== null) {
                        let totalAmount = amount;

                        fullHistory.forEach(entry => {
                            if (
                                entry.receipt_id !== currentReceiptId &&
                                entry.concept.includes('Abono')
                            ) {
                                const sameWeeks = entry.payedWeeks?.some(w1 =>
                                    payedWeeksToUse.some(w2 => parseInt(w1.paid_is_active) === 1 && w1.week === `${w2.weekNum}-${w2.year}`)
                                );

                                if (sameWeeks) {
                                    const entryAmounts = entry.amount?.split(',').map(a => a.trim()) || [];
                                    const indexAbono = Object.keys(entry.conceptPercentages).findIndex(k => k === 'Abono');
                                    const prevAmount = entryAmounts[indexAbono] ? parseFloat(entryAmounts[indexAbono]) : 0;
                                    totalAmount += prevAmount;
                                }
                            }
                        });
                        let totalToPay = 0;

                        if (paymentPlan) {
                            // 🔸 Filtramos solo las semanas con abonos (percent_paid < 100)
                            const abonoWeeks = payedWeeks
                                ?.filter(w => Number(w.percent_paid) < 100)
                                .map(w => {
                                    const [weekNum, year] = w.week.split('-').map(Number);
                                    return { weekNum, year };
                                }) || [];
                            // 👇 recorremos solo esas semanas de abono
                            /////////////////////////////////////////////////////
                            /////////////ONLINE ONLINE ONLINE////////////////////
                            /////////////////////////////////////////////////////
                            // if (isClassOnline) {
                            if (isClassOnline) {
                                abonoWeeks.forEach(({ weekNum, year }) => {
                                    const ClassDateAbonada = getClassDateOfWeek(weekNum, year, classDays)
                                    // Deadline: día de clase + 10 días
                                    const promptDeadline = new Date(ClassDateAbonada);
                                    promptDeadline.setDate(promptDeadline.getDate() + 10);
                                    const promptStr = toYMD(promptDeadline);
                                    if (today <= promptStr) {
                                        totalToPay = paymentPlan.prompt;
                                    } else {
                                        totalToPay = paymentPlan.late;
                                    }
                                });
                            } else {
                                /////////////////////////////////////////////////////
                                /////////////PRESENCIAL PRESENCIAL PRESENCIAL////////
                                /////////////////////////////////////////////////////
                                abonoWeeks.forEach(({ weekNum, year }) => {
                                    const paymentType = getPresentialPaymentType(weekNum, year, classDays);
                                    if (paymentType === "late") {
                                        totalToPay = paymentPlan.late;
                                    } else if (paymentType === "prompt") {
                                        totalToPay = paymentPlan.prompt;
                                    } else {
                                        totalToPay = paymentPlan.normal;
                                    }
                                });


                            }
                        } else {
                            totalToPay = (100 * totalAmount) / percentNumber;
                        }
                        const remaining = roundToNearestHalf(totalToPay - totalAmount);
                        extraInfo = ` - Restante por pagar: $${remaining}`;

                    }

                    return (
                        <div
                            key={index}
                            className={isRefunded ? 'concept-refunded' : percentNumber < 100 ? 'partial-pay' : ''}
                        >
                            {/* 🔹 TEXTO PRINCIPAL */}
                            {isRefunded ? (
                                `${concept}: ${conceptNameST} ($${amount})`
                            ) : (
                                `${concept}: ${percent} ($${amount})`
                            )}

                            {/* 🔹 TEXTO SECUNDARIO */}
                            {!isRefunded && (
                                <div className="partialpay-remaining">
                                    {percentNumber < 100 ? `PAGO PARCIAL ${extraInfo}` : 'COMPLETADO'}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        );

        return percentJSX;
    };

    // Ordenar por fecha de recibo descendente (más reciente primero)
    const sortedHistory = [...paymentHistory].sort((a, b) => {
        const dateA = a.receipt_date.length === 10
            ? getLocalDateObjectFromInput(a.receipt_date)
            : new Date(a.receipt_date);
        const dateB = b.receipt_date.length === 10
            ? getLocalDateObjectFromInput(b.receipt_date)
            : new Date(b.receipt_date);
        return dateB - dateA; // Descendente
    });

    const handleRePrintReceipt = async (receiptId) => {
        const responseReceiptToReprint = await GetPaymentReceiptByIDToReprint(receiptId)
        if (responseReceiptToReprint.status === 200) {
            setReceiptData(responseReceiptToReprint.result)
            setIsOpenPrintReceipt(true)
        }
    }



    const handleCancel = async (receiptId) => {
        openConfirm(
            'Cancelar recibo',
            '¿Seguro que desea cancelar el recibo?',
            {
                type: 'CANCEL_RECEIPT',
                receiptId,
            }
        );
    };
    const handleChangePaymentMethod = async (receipt) => {
        openConfirm(
            'Cambiar metodo de pago.',
            '¿Seguro que desea cambiar el metodo de pago?',
            {
                type: 'CHANGE_PAYMENT_METHOD_RECEIPT',
                receipt,
            }
        );
    };
    const handleRefund = async (receipt_id) => {
        openConfirm(
            'Reembolso.',
            '¿Seguro desea realizar un reembolso del recibo?',
            {
                type: 'REFUND_RECEIPT',
                receipt_id,
            }
        );
    };

    const getReceiptType = (isShared, students) =>{
        const nameStudents = students.map((v)=>v.student_name).join(', ')
        return (
            <Tooltip text={nameStudents} position="left">
                <span className={isShared ? 'shared' : 'single'}>
                    {isShared ? 'Compartido' : 'Único'}
                </span>
            </Tooltip>
        );
    };
    //Table data 
    const data = sortedHistory.map(payment => {
        const dateRange = filterWeeks(payment);
        const concepts = splitConcepts(payment.conceptPercentages);
        const percents = splitPercents(payment.conceptPercentages, payment.amount, sortedHistory,
            payment.receipt_id, payment.payedWeeks, payment.concept_st
        );
        const lastReceiptId = sortedHistory?.[0]?.receipt_id;
        const weeksPaid = Array.isArray(payment.payedWeeks)
            ? payment.payedWeeks.filter(w => w.week !== "-" && w.percent_paid !== "").length
            : 0;
        return {
            actions: <div className={payment.receipt_id === lastReceiptId && showActions ? 'group-act-buttons-flex' : 'group-act-buttons'}>
                <Tooltip text={'Reimprimir recibo'} position='right'>
                    <Button Icon={PrintSVG} backgroundColor="transparent" onClick={() => handleRePrintReceipt(payment.receipt_id)}></Button>
                </Tooltip>
                {payment.receipt_id === lastReceiptId && showActions && (
                    <>
                        <Tooltip text="Cambiar metodo de pago" position="right">
                            <Button
                                Icon={ChangeArrowSVG}
                                backgroundColor="transparent"
                                onClick={() => handleChangePaymentMethod(payment)}
                                disabled={payment.st !== 'PAID' || Boolean(payment.cash_audit_id) || payment.refund_status !== 'NONE'}
                                className="payment_history-button-disabled"
                            />
                        </Tooltip>
                        <Tooltip text="Cancelar recibo" position="right">
                            <Button
                                Icon={CancelSVG}
                                backgroundColor="transparent"
                                onClick={() => handleCancel(payment.receipt_id)}
                                disabled={payment.st !== 'PAID' || Boolean(payment.cash_audit_id) || payment.refund_status !== 'NONE'}
                                className="payment_history-button-disabled"

                            />
                        </Tooltip>
                        <Tooltip text="Reembolsar" position="right">
                            <Button
                                Icon={RefundSVG}
                                backgroundColor="transparent"
                                onClick={() => handleRefund(payment.receipt_id)}
                                disabled={payment.st !== 'PAID' || payment.refund_status !== 'NONE'}
                                className="payment_history-button-disabled"
                            />
                        </Tooltip>

                    </>
                )}
            </div>,
            receiptId: 'R' + payment.receipt_id || 'Recivo no encontrado',
            date: payment.receipt_date || "Fecha no proporcionada",
            concept: concepts || "Concepto no proporcionado",
            dateRange,
            amount: payment.amount ? `$ ${payment.amount}` : "$ 0.00",
            weeksPaid,
            percent_paid: percents,
            st_receipt: payment.st || '',
            st_refund_status_receipt: payment.refund_status || '',
            receiptType: getReceiptType(payment.is_shared,payment.students)
            // students:payment.students.map((v)=> v.student_name).join(', ') || '',
            // is_shared: payment.is_shared
        };
    });
    const handleRowStatus = (fila) => {
        const statusReceipt = fila.st_receipt || '';
        const status_refund_receipt = fila.st_refund_status_receipt || ''
        if (statusReceipt === "CANCELLED") {
            switch (status_refund_receipt) {
                case 'NONE':
                    return 'payment-history-cancelled-receipt'

                case 'PENDING':

                    break;
                case 'PARTIAL REFUNDED':
                    return 'payment-history-partial-refunded-receipt'

                case 'REFUNDED':
                    return 'payment-history-refunded-receipt'

                default:
                    break;
            }

        }
        if (statusReceipt === "PAID") {
            switch (status_refund_receipt) {
                case 'PENDING':

                    break;
                case 'PARTIAL REFUNDED':
                    return 'payment-history-partial-refunded-receipt'
                case 'REFUNDED':
                    return 'payment-history-refunded-receipt'

                default:
                    break;
            }

        }
        //NONE', 'PENDING', 'PARTIAL REFUNDED', 'REFUNDED
    };
    return (
        <div className={`payment-history-contain scroll ${className}`}>
            <h1 className="title-2">Historial de pago</h1>
            <TableCtsm getRowClass={handleRowStatus} columns={columns} data={data} className={'payment-history-table'} />

        </div>
    );
};

export default PaymentHistory;
